module.exports = __webpack_public_path__ + "img/art4.f1abf740.png";